import { Input } from "reactstrap";
import { AsyncPaginatedSelect } from "components/common/AsyncPaginatedSelect";
import { getClientOptions } from "features/Clients/services/ClientService";
import {
  EnquiryIntent,
  EnquiryIntentLabelMap,
  EnquiryStatus,
  enquiryStatusMap,
} from "features/Enquiries/constants/enquiry.constants";
import type { SelectOption } from "types/api.types";

export type EnquiryListFiltersProps = {
  status: string;
  onStatusChange: (value: string) => void;
  intent: string;
  onIntentChange: (value: string) => void;
  clientId: number | null;
  onClientIdChange: (value: number | null) => void;
};

export default function EnquiryListFilters({
  status,
  onStatusChange,
  intent,
  onIntentChange,
  clientId,
  onClientIdChange,
}: EnquiryListFiltersProps) {
  return (
    <div className="d-flex align-items-center gap-2 flex-wrap">
      <Input
        type="select"
        className="form-select"
        style={{ width: 150 }}
        value={status}
        onChange={(e) => onStatusChange(e.target.value)}
      >
        <option value="">All statuses</option>
        {(Object.values(EnquiryStatus) as EnquiryStatus[]).map((s) => (
          <option key={s} value={s}>
            {enquiryStatusMap[s]?.label ?? s}
          </option>
        ))}
      </Input>
      <Input
        type="select"
        className="form-select"
        style={{ width: 150 }}
        value={intent}
        onChange={(e) => onIntentChange(e.target.value)}
      >
        <option value="">All intents</option>
        {(Object.values(EnquiryIntent) as EnquiryIntent[]).map((i) => (
          <option key={i} value={i}>
            {EnquiryIntentLabelMap[i] ?? i}
          </option>
        ))}
      </Input>
      <div style={{ width: 200 }}>
        <AsyncPaginatedSelect
          fetchOptions={getClientOptions}
          placeholder="Client…"
          value={clientId}
          onChange={(opt) =>
            onClientIdChange(
              opt && !Array.isArray(opt)
                ? Number((opt as SelectOption).value)
                : null,
            )
          }
        />
      </div>
    </div>
  );
}
